function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import careersConfig from "./careers-config.json";
import { getPositionDetailsByID } from "/server/services/comeet-service/comeet-service";
import { DEFAULT_UNLISTED_POSITION_DATA, UNLISTED_POSITION_ID } from "/constants/careers/careers";
import { isPositionRelevantToType } from "/server/services/comeet-service/position-type-service";
const LOCATIONS = {
    london: [
        "london"
    ],
    miami: [
        "miami"
    ],
    newyork: [
        "york"
    ],
    sf: [
        "sf",
        "san franc"
    ],
    sydney: [
        "sydney"
    ],
    telaviv: [
        "aviv"
    ],
    tokyo: [
        "tokyo"
    ],
    chicago: [
        "chicago"
    ],
    saopaulo: [
        "sao paulo"
    ],
    denver: [
        "denver"
    ],
    houston: [
        "houston"
    ],
    austin: [
        "austin"
    ],
    warsaw: [
        "warsaw",
        "warsha"
    ],
    singapore: [
        "singapore"
    ],
    melbourne: [
        "melbourne"
    ],
    paris: [
        "paris"
    ],
    munich: [
        "munich"
    ],
    "remote-us": [
        "remoteus",
        "remote, us",
        "remote-us",
        "remote_us",
        "remote us",
        "us remote"
    ]
};
const DEPARTMENTS = {
    customersucc: [
        "cs",
        "client relations",
        "customer succ"
    ],
    marketing: [
        "marketing"
    ],
    hr: [
        "hr"
    ],
    rnd: [
        "r&d"
    ],
    design: [
        "design"
    ],
    product: [
        "product"
    ],
    finance: [
        "finance"
    ],
    consulting: [
        "consulting"
    ],
    partnership: [
        "partnership"
    ],
    businessoperations: [
        "business operations"
    ],
    operations: [
        "operation"
    ],
    sfs: [
        "sfs"
    ],
    communications: [
        "communications"
    ],
    legal: [
        "legal"
    ],
    socialimpact: [
        "socialimpact"
    ],
    payments: [
        "payments"
    ],
    gtm: [
        "gtm"
    ]
};
const getDeptIdFromName = (deptComeetName)=>{
    const deptInfo = careersConfig.departments.find((d)=>d.name === deptComeetName);
    return deptInfo === null || deptInfo === void 0 ? void 0 : deptInfo.id;
};
const getDeptID = (departmentName)=>{
    const configMatch = getDeptIdFromName(departmentName);
    if (configMatch) return configMatch;
    if (!departmentName) return null;
    const normalizedName = departmentName.toLowerCase();
    if (normalizedName.includes("unlisted")) return null;
    for (const [deptId, patterns] of Object.entries(DEPARTMENTS)){
        if (patterns.some((pattern)=>normalizedName.includes(pattern))) {
            return deptId;
        }
    }
    console.error("Failed to match department for:", departmentName);
    return null;
};
//HELPER METHOD
const getDeptIDFromPosition = (posObj)=>{
    //returns dept ID from a Comeet position obj
    const deptID = getDeptID(posObj.department);
    return deptID;
};
//HELPER METHOD
const getDeptInfo = (posObj)=>{
    const deptID = getDeptIDFromPosition(posObj);
    if (!deptID) {
        console.error("Failed to getDeptInfo", posObj);
        return;
    }
    const deptInfo = careersConfig.departments.find((d)=>d.id === deptID);
    if (!deptInfo) {
        console.error("Failed to find team for ID -", deptID);
        return;
    }
    return deptInfo;
};
const getLocationID = (locationName)=>{
    if (!locationName) return null;
    const normalizedLocation = locationName.toLowerCase().trim();
    for (const [locationId, patterns] of Object.entries(LOCATIONS)){
        if (patterns.some((pattern)=>normalizedLocation.includes(pattern))) {
            return locationId;
        }
    }
    console.error("Failed to match location for:", locationName);
    return null;
};
//HELPER METHOD
const getLocationInfoFromPosition = (posObj)=>{
    const locID = getLocationIDFromPosition(posObj);
    if (!locID) return;
    const locInfo = careersConfig.locations.find((loc)=>loc.id == locID);
    if (!locInfo) {
        console.error("Failed to find locInfo for locID -", locID, posObj);
        return;
    }
    return locInfo;
};
const getLocationIDFromPosition = (posObj)=>{
    const locID = getLocationID(posObj.location.name);
    return locID;
};
const getPositionData = function() {
    var _ref = _async_to_generator(function*(id, positionsType) {
        let positionData;
        try {
            positionData = yield getPositionDetailsByID(id, positionsType);
        } catch (e) {
            if (id === UNLISTED_POSITION_ID) {
                positionData = DEFAULT_UNLISTED_POSITION_DATA;
            } else {
                throw e;
            }
        }
        return positionData;
    });
    return function getPositionData(id, positionsType) {
        return _ref.apply(this, arguments);
    };
}();
const isPositionIdValid = (positionId)=>{
    const pattern = /^[A-F0-9]{2}\.[A-F0-9]{3}$/;
    return pattern.test(positionId);
};
const filterByPositionType = (allPositionsData, positionsType)=>{
    return allPositionsData.filter((position)=>isPositionRelevantToType(position, positionsType));
};
module.exports = {
    UNLISTED_POSITION_ID,
    getDeptID,
    getDeptIDFromPosition,
    getDeptInfo,
    getLocationID,
    getLocationInfoFromPosition,
    getLocationIDFromPosition,
    getPositionData,
    filterByPositionType,
    isPositionIdValid
};
